import { useState, useEffect } from "react";
import { apiClient } from "../../App";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";

const TYPES = ["ARCHITECT", "INTERIOR_DESIGNER", "LANDSCAPE_ARCHITECT", "DEVELOPER", "BROKER", "CONSULTANT", "ENGINEER", "OTHER"];

export default function YellowPageDialog({ open, onOpenChange, editingContact, onSuccess }) {
  const [data, setData] = useState({ contact_type: "ARCHITECT", company_name: "" });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) {
      setData(editingContact ? { ...editingContact } : { contact_type: "ARCHITECT", company_name: "" });
    }
  }, [open, editingContact]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!data.company_name) return toast.error("Company name required");
    
    setSaving(true);
    try {
      if (editingContact) {
        await apiClient.patch(`/yellow-pages/${editingContact.id}`, data);
      } else {
        await apiClient.post("/yellow-pages", data);
      }
      toast.success("Saved");
      onOpenChange(false);
      onSuccess?.();
    } catch (err) {
      toast.error("Failed to save");
    }
    setSaving(false);
  };

  const set = (k, v) => setData({ ...data, [k]: v });

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{editingContact ? "Edit" : "Add"} Contact</DialogTitle>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-3">
          <div>
            <Label>Type</Label>
            <Select value={data.contact_type} onValueChange={(v) => set("contact_type", v)}>
              <SelectTrigger><SelectValue /></SelectTrigger>
              <SelectContent>
                {TYPES.map(t => <SelectItem key={t} value={t}>{t.replace("_", " ")}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
          <div>
            <Label>Company *</Label>
            <Input value={data.company_name || ""} onChange={(e) => set("company_name", e.target.value)} />
          </div>
          <div>
            <Label>Contact</Label>
            <Input value={data.primary_contact || ""} onChange={(e) => set("primary_contact", e.target.value)} />
          </div>
          <div>
            <Label>Email</Label>
            <Input value={data.email || ""} onChange={(e) => set("email", e.target.value)} />
          </div>
          <div>
            <Label>Phone</Label>
            <Input value={data.phone || ""} onChange={(e) => set("phone", e.target.value)} />
          </div>
          <div>
            <Label>Website</Label>
            <Input value={data.website || ""} onChange={(e) => set("website", e.target.value)} />
          </div>
          <div>
            <Label>Address</Label>
            <Input value={data.address || ""} onChange={(e) => set("address", e.target.value)} />
          </div>
          <div>
            <Label>Notes</Label>
            <Textarea value={data.notes || ""} onChange={(e) => set("notes", e.target.value)} rows={2} />
          </div>
          <div className="flex justify-end gap-2 pt-2">
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
            <Button type="submit" disabled={saving}>{saving ? "..." : "Save"}</Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
